import React, { ReactNode } from "react"
import Components from ".."

import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"

import remarkReactComponents from "../../helpers/remarkReactComponents"
import { blokType } from "../../types"
import {
  StyledHero,
  StyledHeroOverImage,
  StyledHeroContainer,
  StyledHeroCard,
  StyledHeroImage,
  StyledHeroTitle,
  StyledHeroDescription,
  StyledHeroSubTitle,
  StyledHeroButtons,
} from "./partials"

export interface HeroDegreeProps {
  title: string
  sub_title: string
  description: string
  cta_button: blokType[]
  hero_image: blokType[]
  id: string,
  custom_id: string,
}

class HeroDegreeCmp extends React.Component<HeroDegreeProps> {
  state = {
    header_height: "",
  }
  componentDidMount() {
    var getHeaderHeight = document.getElementById("site-header")?.offsetHeight
    this.setState({
      header_height: getHeaderHeight,
    })
  }
  render() {
    return (
      <StyledHero data-name="hero-degree" header_height={this.state.header_height} id={this.props.custom_id ? this.props.custom_id : this.props.id}>
        {this.props.hero_image.length > 0 && (
          <StyledHeroImage
            header_height={this.state.header_height}
            mobileOnly={false}
          >
            {this.props.hero_image.map((content) =>
              React.createElement(Components(content.component), {
                key: content._uid,
                blok: content,
              })
            )}
          </StyledHeroImage>
        )}
        <StyledHeroOverImage>

          <StyledHeroContainer>
            <StyledHeroCard>
              {this.props.title && (
                <StyledHeroTitle>{this.props.title}</StyledHeroTitle>
              )}
              {this.props.sub_title && (
                <StyledHeroSubTitle>
                  {
                    unified()
                      .use(remarkParse)
                      .use(remarkRehype)
                      .use(rehypeReact as any, {
                        createElement: React.createElement,
                        components: remarkReactComponents,
                        Fragment: React.Fragment
                      })
                      .processSync(this.props.sub_title).result as ReactNode
                  }
                </StyledHeroSubTitle>
              )}
              {this.props.description && (
                <StyledHeroDescription>
                  {
                    unified()
                      .use(remarkParse)
                      .use(remarkRehype)
                      .use(rehypeReact as any, {
                        createElement: React.createElement,
                        components: remarkReactComponents,
                        Fragment: React.Fragment
                      })
                      .processSync(this.props.description).result as ReactNode
                  }
                </StyledHeroDescription>
              )}
              {this.props.cta_button && (
                <StyledHeroButtons>
                  {this.props.cta_button.map((content) =>
                    React.createElement(Components(content.component), {
                      key: content._uid,
                      blok: content,
                    })
                  )}
                </StyledHeroButtons>
              )}
            </StyledHeroCard>
          </StyledHeroContainer>
        </StyledHeroOverImage>
      </StyledHero>
    )
  }
}

export default HeroDegreeCmp
